type Type = 'text' | 'number' | 'textarea' | 'password';
type Name = 'affiliation' | 'fullName' | 'pwz' | 'phone' | 'password' | 'repeatPassword' | 'workPlace';

export interface IFormData {
  name: Name;
  label: string
  type: Type;
  placeholder: string
}

export const formDataPublish: IFormData[] = [
  {
    name: 'password',
    label: 'Hasło',
    type: 'password',
    placeholder: 'Wpisz swoje hasło...'
  },
  {
    name: 'repeatPassword',
    label: 'Powtórz hasło',
    type: 'password',
    placeholder: 'Wpisz ponownie swoje hasło...'
  }
]